import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LockersIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M19 19C19 19.5518 18.5513 20 18 20H6C5.44873 20 5 19.5518 5 19V5C5 4.44824 5.44873 4 5.99609 4H16V2H6C4.3457 2 3 3.3457 3 5V19C3 20.6543 4.3457 22 6 22H18C19.6543 22 21 20.6543 21 19V9H19V19Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M5 5C5 4.44824 5.44873 4 6 4L18 4C18.5513 4 19 4.44824 19 5L19 19C19 19.5518 18.5513 20 18.0039 20H10V22H18C19.6543 22 21 20.6543 21 19L21 5C21 3.3457 19.6543 2 18 2L6 2C4.3457 2 3 3.3457 3 5L3 15L5 15L5 5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18C16.1032 18 17 17.1032 17 16C17 14.8965 16.1021 14 14.9992 14C13.8957 14 13 14.8971 13 16C13 17.1032 13.8968 18 15 18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 6H7V8H13V6Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 12H7V10H13V12Z",
    fill: "currentColor"
  }));
}